export default __webpack_public_path__ + "static/media/Pratima Sonavne.036ba195.jpg";